export default "__VITE_ASSET__DWoOSgAQ__"